import type { Assigner, EventObject } from './types';

/**
 * Create an assignment action that folds resolved data into `context` on a
 * transition. Read event payload via the second argument — type it with the
 * `InvokeDoneEvent<T>` / `InvokeErrorEvent<T>` helpers for invoke transitions:
 *
 * ```ts
 * onDone: {
 *   target: 'next',
 *   actions: assign<Ctx, InvokeDoneEvent<string>>((ctx, event) => ({
 *     region: event.data ?? null,
 *   })),
 * }
 * ```
 */
export function assign<TContext, TEvent extends EventObject = EventObject>(
  assignment: (context: TContext, event: TEvent) => Partial<TContext>
): Assigner<TContext> {
  // `TEvent` narrows the callback for ergonomics; the stored assigner is wide
  // (EventObject) so it fits any transition slot in the pure config.
  return {
    type: '@flow/assign',
    assignment: assignment as Assigner<TContext>['assignment'],
  };
}
